import React from 'react';
import MarkdownConverter from './components/MarkdownConverter';

function App() {
  return (
    <div className="App">
      <MarkdownConverter />
    </div>
  );
}

export default App;